export function blurAll() {
  setTimeout(function () {
    var tmp = document.createElement('input');
    tmp.setAttribute('inputmode', 'none');
    document.body.appendChild(tmp);
    tmp.focus();
    document.body.removeChild(tmp);
  }, 250);
}